import styled from "styled-components";

export const ContainerFilaVirtualMasInfo = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: transparent;
`;

export const FilaVirtualMasInfoTitulo = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  text-align: center;
`;

export const FilaVirtualMasInfoIcono = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 36px;
  text-align: center;
`;
export const FilaVirtualMasInfoTxt = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 36px;
  text-align: center;
`;
export const FilaVirtualMasInfoConoceMasTxt = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin-top: 36px;
  .FilaVirtualMasInfoConoceMasTxt {
    text-decoration: underline;
    cursor: pointer;
  }
`;
export const FilaVirtualMasInfoBotones = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 52px;
  text-align: center;
`;
